<template>
  <div class="item_cla">
    <slot name="icon"></slot>
    <slot name="number"></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.item_cla {
  height: 100%;
  width: 100%;
  background: #f8fcf7;
  border-radius: 2px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .icon_cla {
    height: 80px;
    width: 80px;
    background: #ecfbe8;
    border-radius: 2px 0 0 2px;
    font-size: 30px;
    color: @themeColor;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .tip_cla {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
    letter-spacing: 0;
    text-align: center;
    margin-left: 24px;
    height: 20px;
    line-height: 20px;
  }
  .num_cla {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.9);
    letter-spacing: 0;
    margin-left: 8px;
    height: 33px;
    line-height: 33px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appSetting/charItem.vue